// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3WzNB","label":"styles_label__2_BgG"};